import script from "./TeamCard.vue?vue&type=script&setup=true&lang=js"
export * from "./TeamCard.vue?vue&type=script&setup=true&lang=js"

import "./TeamCard.vue?vue&type=style&index=0&id=31629daa&scoped=true&lang=css"

import exportComponent from "/home/runner/work/INPEOPLE-HUB/INPEOPLE-HUB/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-31629daa"]])

export default __exports__